import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined
const release = import.meta.env.VITE_SENTRY_RELEASE as string | undefined

export function initSentry() {
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: environment || import.meta.env.MODE,
    release,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
  })
}
